import {
  HardHat,
  PaintRoller,
  Cone,
  Zap,
  Wrench,
  Car,
  Gauge,
  Siren,
  Clock,
  Factory,
  Handshake,
  ShieldCheck,
  BadgeCheck,
  MapPin,
  Store,
  Fuel,
  Cog,
  TreePine,
} from "lucide-react";

export const SITE = {
  name: "Petroline Services",
  phone: "905-514-9025",
  phoneHref: "tel:+19055149025",
  addressLine1: "620 Thompson Rd S",
  addressLine2: "Milton, ON L9T 0C7",
};

export const IMAGES = {
  hero: {
    url: "https://images.unsplash.com/photo-1487803556724-cb9f0b8151d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBnYXMlMjBzdGF0aW9uJTIwYXQlMjBuaWdodHxlbnwwfHx8fDE3OTA1NDk1MjZ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Modern gas station forecourt illuminated at night",
  },
  maintenance: {
    url: "https://images.unsplash.com/photo-1660330589693-99889d60181e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxzZXJ2aWNlJTIwdGVjaG5pY2lhbiUyMG1haW50ZW5hbmNlfGVufDB8fHx8MTc5MDU0OTUyNnww&ixlib=rb-4.1.0&q=85",
    alt: "Service technician performing electrical panel maintenance",
  },
  construction: {
    url: "https://images.unsplash.com/photo-1593313637552-29c2c0dacd35?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxjb21tZXJjaWFsJTIwY29uc3RydWN0aW9uJTIwd29ya2VyJTIwYnVpbGRpbmd8ZW58MHx8fHx8MTc5MDU0OTUzM3ww&ixlib=rb-4.1.0&q=85",
    alt: "Construction worker on steel beams at a commercial site",
  },
  carWash: {
    url: "https://images.unsplash.com/photo-1633014041037-f5446fb4ce99?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxjb21tZXJjaWFsJTIwY29uc3RydWN0aW9uJTIwd29ya2VyJTIwYnVpbGRpbmd8ZW58MHx8fHwxNzkwNTQ5NTI2fDA&ixlib=rb-4.1.0&q=85",
    alt: "Car covered in foam at a commercial car wash facility",
  },
  fuelPump: {
    url: "https://images.unsplash.com/photo-1709536240401-58dff8e8d597?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxnYXMlMjBzdGF0aW9uJTIwZnVlbCUyMHB1bXAlMjBub3p6bGUlMjBjbG9zZSUyMHVwfGVufDB8fHx8MTc5MDU0OTUzM3ww&ixlib=rb-4.1.0&q=85",
    alt: "Close-up of a fuel pump nozzle at a dispensing station",
  },
  highway: {
    url: "https://images.unsplash.com/photo-1772992783829-006d1fdc2b6a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxvbnRhcmlvJTIwaGlnaHdheSUyMHRydWNrc3xlbnwwfHx8fDE3OTA1NDk1MzN8MA&ixlib=rb-4.1.0&q=85",
    alt: "Ontario highway with commercial traffic at dusk",
  },
};

export const SERVICES = [
  {
    icon: HardHat,
    title: "General Contracting",
    description:
      "Commercial construction, renovations, repairs and project coordination for petroleum retail facilities and related commercial properties.",
  },
  {
    icon: PaintRoller,
    title: "Station Renovations",
    description:
      "Interior and exterior renovation services designed to improve the appearance, functionality and condition of existing fuel-station properties.",
  },
  {
    icon: Cone,
    title: "Forecourt & Site Repairs",
    description:
      "Maintenance and repair services for areas surrounding fuel dispensers, drive lanes, curbs, concrete surfaces and other forecourt components.",
  },
  {
    icon: Zap,
    title: "Electrical Services",
    description:
      "Commercial electrical repair, maintenance and improvement services for petroleum retail facilities, subject to applicable licensing and regulatory requirements.",
  },
  {
    icon: Wrench,
    title: "Mechanical Services",
    description:
      "Commercial mechanical repair and maintenance support for facility systems and equipment.",
  },
  {
    icon: Car,
    title: "Car-Wash Maintenance",
    description:
      "Repair, maintenance and facility-support services for automatic and self-serve car-wash operations.",
  },
  {
    icon: Gauge,
    title: "Equipment Maintenance",
    description:
      "Maintenance and repair coordination for equipment and operational components used throughout petroleum retail facilities.",
  },
  {
    icon: Siren,
    title: "Emergency Maintenance",
    description:
      "Responsive service for urgent facility issues that require prompt attention to help minimize disruption to business operations.",
  },
];

export const BENEFITS = [
  {
    icon: Clock,
    title: "Responsive Service",
    description: "Prompt communication and practical solutions when maintenance issues arise.",
  },
  {
    icon: Factory,
    title: "Commercial Focus",
    description: "Services designed around commercial properties and operational environments.",
  },
  {
    icon: Handshake,
    title: "One Service Partner",
    description: "A broad range of contracting, repair, renovation and maintenance capabilities.",
  },
  {
    icon: ShieldCheck,
    title: "Preventive Mindset",
    description: "Focus on identifying maintenance needs before they become larger operational problems.",
  },
  {
    icon: BadgeCheck,
    title: "Professional Workmanship",
    description: "Clean, organized and professional execution of commercial projects.",
  },
  {
    icon: MapPin,
    title: "Ontario-Based",
    description: "Based in Milton and serving petroleum retail facilities throughout Southern Ontario.",
  },
];

export const RETAIL_AREAS = [
  { icon: Store, label: "Retail Areas" },
  { icon: Cone, label: "Forecourts" },
  { icon: Fuel, label: "Fuel Areas" },
  { icon: Car, label: "Car Washes" },
  { icon: Cog, label: "Building Systems" },
  { icon: TreePine, label: "Exterior Areas" },
];

export const PROJECT_CATEGORIES = [
  { title: "Gas Station Renovation", image: "hero", tag: "Renovation" },
  { title: "Forecourt Repairs", image: "fuelPump", tag: "Site Work" },
  { title: "Convenience Store Improvements", image: "construction", tag: "Interior" },
  { title: "Car-Wash Maintenance", image: "carWash", tag: "Maintenance" },
  { title: "Electrical & Mechanical Work", image: "maintenance", tag: "Systems" },
  { title: "Exterior Repairs", image: "construction", tag: "Building Envelope" },
  { title: "Preventive Maintenance", image: "maintenance", tag: "Planned Care" },
  { title: "Emergency Service", image: "hero", tag: "Responsive" },
];

export const CITIES = [
  "Milton",
  "Mississauga",
  "Oakville",
  "Burlington",
  "Brampton",
  "Vaughan",
  "Toronto",
  "Hamilton",
  "Guelph",
  "Cambridge",
  "Kitchener-Waterloo",
];

export const INDUSTRIES_SERVED = [
  "Branded gas stations",
  "Independent fuel stations",
  "Convenience stores attached to fuel stations",
  "Petroleum retailers and operators",
  "Car-wash operators",
  "Commercial property operators",
  "Multi-location fuel-station operators",
  "Property and facility managers",
];

export const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Services", href: "/services" },
  { label: "Industries", href: "/industries" },
  { label: "Projects", href: "/projects" },
  { label: "Service Areas", href: "/service-areas" },
  { label: "Contact", href: "/contact" },
];
